<template>
  <div>
    <!--报名-->
    <div class="sign_up">
      <!--背景-->
      <div class="bg posr">
        <img src="@/assets/images/banner.png" style="height: auto;" class="w100">
        <div class="dif alc logo_warp">
          <img :src="$store.state.url+logo">
          <div class="mrLft20 site_title">{{title}}</div>
        </div>
      </div>
      <div class="router">
        <el-breadcrumb separator="/">
          <!--<el-breadcrumb-item :to="{ path: '/' }">首页</el-breadcrumb-item>-->
          <el-breadcrumb-item>网上报名</el-breadcrumb-item>
        </el-breadcrumb>
      </div>
      <!--步骤条-->
      <div>
        <el-steps :active="active" align-center>
          <el-step title="第一步" description="填写报名信息"></el-step>
          <el-step title="第二步" description="确认报名信息"></el-step>
          <el-step title="第三步" description="交纳报名费"></el-step>
        </el-steps>
      </div>
      <!--填写基本信息和确认信息-->
      <div v-if="active===1 || active===2" style="margin-top: 4rem;">
        <!--填写基本信息-->
        <div class="warp">
          <h2 class="warp_title" style="font-size: 16px;">填写基本信息</h2>
          <el-row>
            <!--姓名-->
            <el-col :span="12" :xs="24" class="dif alc item">
              <div class="fs16 dif alc ">
                <span style="color: #EE2352">*</span>
                <div class="col101010" style="font-size: 14px;">姓名</div>
              </div>
              <div class="mrLft20 w70">
                <el-input placeholder="请输入姓名" :disabled="is_disabled" v-model="name"></el-input>
              </div>
            </el-col>
            <!--民族-->
            <el-col :span="12" :xs="24" class="dif alc item">
              <div class="fs16 dif alc ">
                <span style="color: #EE2352">*</span>
                <div class="col101010" style="font-size: 14px;">民族</div>
              </div>
              <div class="mrLft20 w70">
                <el-select v-model="nation" :disabled="is_disabled">
                  <el-option
                    v-for="(item,index) in nations" :key="index"
                    :label="item"
                    :value="item"
                  ></el-option>
                </el-select>
              </div>
            </el-col>
            <!--性别-->
            <el-col :span="12" :xs="24" class="dif alc item">
              <div class="fs16 dif alc ">
                <span style="color: #EE2352">*</span>
                <div class="col101010" style="font-size: 14px;">性别</div>
              </div>
              <div class="mrLft20 w70">
                <el-radio v-model="gender" label="1" :disabled="is_disabled">男</el-radio>
                <el-radio v-model="gender" label="2" :disabled="is_disabled">女</el-radio>
              </div>
            </el-col>
            <!--出生日期-->
            <el-col :span="12" :xs="24" class="dif alc item">
              <div class="fs16 dif alc ">
                <span style="color: #EE2352">*</span>
                <div class="col101010" style="font-size: 14px;">出生日期</div>
              </div>
              <div class="mrLft20 w70">
                <el-date-picker
                    :disabled="is_disabled"
                    v-model="birth"
                    type="date"
                    value-format="yyyy-MM-dd"
                    placeholder="选择日期">
                </el-date-picker>
              </div>
            </el-col>
            <!--是否工作-->
            <el-col :span="12" :xs="24" class="dif alc item">
              <div class="fs16 dif alc ">
                <span style="color: #EE2352">*</span>
                <div class="col101010" style="font-size: 14px;">是否工作</div>
              </div>
              <div class="mrLft20 w70">
                <el-radio v-model="is_work" label="1" :disabled="is_disabled">是</el-radio>
                <el-radio v-model="is_work" label="0" :disabled="is_disabled">否</el-radio>
              </div>
            </el-col>
            <!--身份证号-->
            <el-col :span="12" :xs="24" class="dif alc item">
              <div class="fs16 dif alc ">
                <span style="color: #EE2352">*</span>
                <div class="col101010" style="font-size: 14px;">身份证号</div>
              </div>
              <div class="mrLft20 w70">
                <el-input placeholder="请输入身份证号" maxlength="18" v-model="number" :disabled="is_disabled"></el-input>
              </div>
            </el-col>
          </el-row>
        </div>
        <!--填写联系方式-->
        <div class="warp mrTop30">
          <h2 class="warp_title" style="font-size: 16px;">填写联系方式</h2>
          <el-row>
            <!--联系电话-->
            <el-col :span="12" :xs="24" class="dif alc item">
              <div class="fs16 dif alc ">
                <span style="color: #EE2352">*</span>
                <div class="col101010" style="font-size: 14px;">联系电话</div>
              </div>
              <div class="mrLft20 w70">
                <el-input placeholder="请输入联系电话" v-model="tel" :disabled="is_disabled"></el-input>
              </div>
            </el-col>
            <!--户籍地址-->
            <el-col :span="12" :xs="24" class="dif alc item">
              <div class="fs16 dif alc ">
                <span style="color: #EE2352">*</span>
                <div class="col101010" style="font-size: 14px;">户籍地址</div>
              </div>
              <div class="mrLft20 w70">
                <el-input placeholder="请输入户籍地址" v-model="huji" :disabled="is_disabled"></el-input>
              </div>
            </el-col>
            <!--邮件地址-->
            <el-col :span="12" :xs="24" class="dif alc item">
              <div class="fs16 dif alc ">
                <span style="color: #EE2352">*</span>
                <div class="col101010" style="font-size: 14px;">邮件地址</div>
              </div>
              <div class="mrLft20 w70">
                <el-input placeholder="请输入邮件地址" v-model="youjian" :disabled="is_disabled"></el-input>
              </div>
            </el-col>
            <!--邮寄地址-->
            <el-col :span="12" :xs="24" class="dif mrTop10">
              <div class="fs16 dif  ">
                <span style="color: #EE2352">*</span>
                <div class="col101010" style="font-size: 14px;">邮寄地址</div>
              </div>
              <div class="mrLft20 w70">
                <el-input placeholder="请输入邮寄地址" v-model="youji" type="textarea" rows="5" :disabled="is_disabled"></el-input>
              </div>
            </el-col>
          </el-row>
        </div>
        <!--填写报考志愿-->
        <div class="warp mrTop30">
          <h2 class="warp_title" style="font-size: 16px;">填写报考志愿</h2>
          <el-row>
            <!--目前学历-->
            <el-col :span="12" :xs="24" class="dif alc item">
              <div class="fs16 dif alc ">
                <span style="color: #EE2352">*</span>
                <div class="col101010" style="font-size: 14px;">目前学历</div>
              </div>
              <div class="mrLft20 w70">
                <el-select v-model="nowXueli" placeholder="请选择" :disabled="is_disabled">
                  <el-option
                      v-for="item in nowXueliArr"
                      :key="item.value"
                      :label="item.label"
                      :value="item.value">
                  </el-option>
                </el-select>
              </div>
            </el-col>
            <!--报考学历-->
            <el-col :span="12" :xs="24" class="dif alc item">
              <div class="fs16 dif alc ">
                <span style="color: #EE2352">*</span>
                <div class="col101010" style="font-size: 14px;">报考学历</div>
              </div>
              <div class="mrLft20 w70">
                <el-select v-model="applyXueli" placeholder="请选择" :disabled="is_disabled">
                  <el-option
                      v-for="item in applyXueliArr"
                      :key="item.value"
                      :label="item.label"
                      :value="item.value">
                  </el-option>
                </el-select>
              </div>
            </el-col>
            <!--报考学科-->
            <el-col :span="12" :xs="24" class="dif alc item">
              <div class="fs16 dif alc ">
                <span style="color: #EE2352">*</span>
                <div class="col101010" style="font-size: 14px;">报考学科</div>
              </div>
              <div class="mrLft20 w70">
                <el-select v-model="applyXueke" placeholder="请选择" :disabled="is_disabled">
                  <el-option
                      v-for="item in applyXuekeArr"
                      :key="item.id"
                      :label="item.name"
                      :value="item.id">
                  </el-option>
                </el-select>
              </div>
            </el-col>
            <!--报考专业-->
            <el-col :span="12" :xs="24" class="dif alc item">
              <div class="fs16 dif alc ">
                <span style="color: #EE2352">*</span>
                <div class="col101010" style="font-size: 14px;">报考专业</div>
              </div>
              <div class="mrLft20 w70">
                <el-select v-model="applyZhuanye" placeholder="请选择" :disabled="is_disabled">
                  <el-option
                      v-for="item in applyZhuanyeArr"
                      :key="item.id"
                      :label="item.name"
                      :value="item.id">
                  </el-option>
                </el-select>
              </div>
            </el-col>
            <!--报考学校-->
            <el-col :span="12" :xs="24" class="dif alc item">
              <div class="fs16 dif alc ">
                <span style="color: #EE2352">*</span>
                <div class="col101010" style="font-size: 14px;">报考学校</div>
              </div>
              <div class="mrLft20 w70">
                <el-select v-model="applySchool" placeholder="请选择" :disabled="is_disabled">
                  <el-option
                      v-for="item in schoolArr"
                      :key="item.id"
                      :label="item.name"
                      :value="item.id">
                  </el-option>
                </el-select>
              </div>
            </el-col>
          </el-row>
        </div>
        <!--填写报名确认点-->
        <div class="warp mrTop30">
          <h2 class="warp_title" style="font-size: 16px;">填写报名确认点</h2>
          <el-row>
            <!--考试地区-->
            <el-col :span="12" :xs="24" class="dif alc item">
              <div class="fs16 dif alc ">
                <span style="color: #EE2352">*</span>
                <div class="col101010" style="font-size: 14px;">考试地区</div>
              </div>
              <div class="mrLft20 w70">
                <el-cascader
                    size="large"
                    :options="options"
                    v-model="area"
                    :disabled="is_disabled"
                    @change="setArea">
                </el-cascader>
              </div>
            </el-col>
            <!--确认地点-->
            <el-col :span="12" :xs="24" style="height: 80px;" class="dif alc item">
              <div class="fs16 dif alc">
                <span style="color: #EE2352">*</span>
                <div class="col101010" style="font-size: 14px;">确认地点</div>
              </div>
              <div class="mrLft20 w70">
                <el-cascader
                    size="large"
                    :options="options"
                    v-model="confirmAddress"
                    :disabled="is_disabled"
                    @change="setConfirm">
                </el-cascader>
                <div class="col999" style="font-size: 12px;">审查/照相/报名信息确认地点，报名成功后不允许修改</div>
              </div>
            </el-col>
            <!--登录密码-->
            <el-col :span="12" :xs="24" style="height: 80px;" class="dif alc item">
              <div class="fs16 dif alc">
                <span style="color: #EE2352">*</span>
                <div class="col101010" style="font-size: 14px;">登录密码</div>
              </div>
              <div class="mrLft20 w70">
                <el-input type="password" placeholder="请输入登录密码，限50字符" maxlength="50" v-model="password" :disabled="is_disabled"></el-input>
                <div class="col999" style="font-size: 12px;">请记住密码，查询录取名单时用到</div>
              </div>
            </el-col>
            <!--指导老师-->
            <el-col :span="12" :xs="24" class="dif alc item">
              <div class="fs16 dif alc">
                <span style="color: #EE2352">*</span>
                <div class="col101010" style="font-size: 14px;">指导老师</div>
              </div>
              <div class="mrLft20 w70">
                <el-input placeholder="请输入指导老师姓名" :disabled="is_disabled" v-model="teacherName"></el-input>
              </div>
            </el-col>
          </el-row>
        </div>
        <!--重置和下一步-->
        <div class="mrTop30 button_warp">
          <el-col :span="12" :xs="24" class="difcac">
            <div class="difcac button2 pointer" @click="reset()" v-if="active===1">重置</div>
            <div class="difcac button2 " style="opacity: 0;" v-if="active===2">上一步</div>
          </el-col>
          <el-col :span="12" :xs="24" class="difcac">
            <div class="difcac button1 pointer" @click="submit()" v-if="active===1">提交信息</div>
            <div class="difcac button1 pointer" v-if="active===2" @click="showPay()">提交</div>
          </el-col>
        </div>
      </div>
      <!--第三步交纳报名费-->
      <div v-if="active===3" style="padding: 3rem;" class="box">
        <!--缴纳报名费-->
        <div class="fs22 bold col101010">缴纳报名费：</div>
        <div class="difcc">
          <!--价格-->
          <div style="color: #FFA940">
            <span style="font-size: 4rem;" class="bold">{{price}}</span>
            <span style="font-size: 2.4rem;" class="mrLft20">元</span>
          </div>
          <!--二维码-->
          <div class="code">
            <img :src="$store.state.url+ercode" class="w100 h100">
          </div>
          <!--说明-->
          <div style="color: #FFA940" class="fs16 bold">扫码转账后请截图在下方上传转账凭证</div>
        </div>
        <!--上传凭证-->
        <div class="fs22 bold col101010" style="margin-top: 5rem;">上传凭证：</div>
        <div class="dif mrTop30 ">
          <div class="difcc">
            <el-upload
                class="upLoad_warp"
                action="https://jybks.chuxingshi.top/api/index/upload"
                :show-file-list="false"
                name="file"
                :on-success="onsuccess">
              <div class="difcc">
                <div class="upLoad difcc" v-if="payImg===''">
                  <i class="el-icon-plus fs30 bold" style="color: rgba(0, 0, 0, 0.45);"></i>
                  <p class="fs12 mrTop10" style="color: rgba(0, 0, 0, 0.65);">上传照片</p>
                </div>
                <div v-else class="upLoad">
                  <img :src="$store.state.url+payImg" class="w100 h100">
                </div>
              </div>
            </el-upload>
          </div>
        </div>
        <div class="difcac button1 pointer" style="width: 50%;margin: 5rem auto;"  @click="paySubmit()">提交</div>
      </div>
      <!--邀请报名-->
      <div v-if="active===4" class="box" style="padding: 3rem;">
        <invitation></invitation>
      </div>
    </div>
    <foot></foot>

  </div>
</template>

<script>
import Foot from "@/components/foot";
import Invitation from "@/components/myCenter/invitation";
import {regionData, CodeToText, TextToCode } from 'element-china-area-data'
const cubic = value => Math.pow(value, 3);
const easeInOutCubic = value => value < 0.5
    ? cubic(value * 2) / 2
    : 1 - cubic((1 - value) * 2) / 2;
export default {
  name: "signUp",
  components: {Invitation, Foot},
  data() {
    return {
      logo: '',
      title: '',
      active: 1,//当前步骤
      options: regionData,
      value: '',
      nations: ["汉族","蒙古族","回族","藏族","维吾尔族","苗族","彝族","壮族","布依族","朝鲜族","满族","侗族","瑶族","白族","土家族",
        "哈尼族","哈萨克族","傣族","黎族","傈僳族","佤族","畲族","高山族","拉祜族","水族","东乡族","纳西族","景颇族","柯尔克孜族",
        "土族","达斡尔族","仫佬族","羌族","布朗族","撒拉族","毛南族","仡佬族","锡伯族","阿昌族","普米族","塔吉克族","怒族", "乌孜别克族",
        "俄罗斯族","鄂温克族","德昂族","保安族","裕固族","京族","塔塔尔族","独龙族","鄂伦春族","赫哲族","门巴族","珞巴族","基诺族"],
      is_disabled: false,//是否禁用
      name: '',//姓名
      nation: '汉族',//民族
      gender: '1',//性别
      birth: '',//出生日期
      is_work: '1',//是否工作
      number: '',//身份证
      tel: '',//联系电话
      huji: '',//户籍地址
      youjian: '',//邮件地址
      youji: '',//邮寄地址
      nowXueli: '',//目前学历
      applyXueli: '',//报考学历
      applyZhuanye: '',//报考专业
      applyXueke: '',//报考学科
      applySchool: '',//报考学校
      area: '',//考试地区
      area2: '',//考试地区
      confirmAddress: '',//确认地点
      confirmAddress2: '',//确认地点
      password: '',//登录密码
      teacherName: '',//指导老师姓名
      payImg: '',

      //滚动动画
      el: null,
      container: null,
      visible: false,

      //选择项
      nowXueliArr: [ //当前学历
        {value: '小学',label: '小学'},
        {value: '初中',label: '初中'},
        {value: '高中',label: '高中'},
        {value: '专科',label: '专科'},
        {value: '本科',label: '本科'},
      ],
      applyXueliArr: [ //报考学历
        {value: 1,label: '专科'},
        {value: 2,label: '本科'},
      ],
      applyZhuanyeArr: [],//报考专业
      applyXuekeArr: [],//报考学科
      schoolArr: [],//报考学校

      //支付图片和金额
      price: '',
      ercode: '',
    }
  },
  methods: {
    //获取logo和标题
    getLogoTitle() {
      this.$axios("POST","/index/cms_system",{})
          .then(res => {
            if(res.code===1) {
              this.logo = res.data.image
              this.title = res.data.title
            }
          })
    },
    init() { //初始化滚动
      document.body.scrollTop = document.documentElement.scrollTop = 0;
      this.container = document;
      this.el = document.documentElement;
      if (this.target) {
        this.el = document.querySelector(this.target);
        if (!this.el) {
          throw new Error(`target is not existed: ${this.target}`);
        }
        this.container = this.el;
      }
    },
    scrollToTop() { //回到顶部 动画
      const el = this.el;
      const beginTime = Date.now();
      const beginValue = el.scrollTop;
      const rAF = window.requestAnimationFrame || (func => setTimeout(func, 16));
      const frameFunc = () => {
        const progress = (Date.now() - beginTime) / 500;
        if (progress < 1) {
          el.scrollTop = beginValue * (1 - easeInOutCubic(progress));
          rAF(frameFunc);
        } else {
          el.scrollTop = 0;
        }
      };
      rAF(frameFunc);
    },
    prev() { //上一步
      this.scrollToTop()
      this.active = 1
      this.is_disabled = false
    },
    reset() { //重置

    },
    submit() { //提交信息
      if(this.name==='') {
        this.$alert('请输入姓名')
        return
      }else if(this.birth==='') {
        this.$alert('请选择出生日期')
        return;
      }else if(this.number==='') {
        this.$alert('请输入身份证号')
        return
      }else if(this.tel==='') {
        this.$alert('请输入联系电话')
        return
      }else if(this.huji==='') {
        this.$alert('请输入户籍地址')
        return
      }else if(this.youjian==='') {
        this.$alert('请输入邮件地址')
        return
      }else if(this.youji==='') {
        this.$alert('请输入邮寄地址')
        return
      }else if(this.nowXueli==='') {
        this.$alert('请选择目前学历')
        return;
      }else if(this.applyXueli==='') {
        this.$alert('请选择报考学历')
        return;
      }else if(this.applyXueke==='') {
        this.$alert('请选择报考学科')
        return;
      }else if(this.applyZhuanye==='') {
        this.$alert('请选择报考专业')
        return
      }else if(this.applySchool==='') {
        this.$alert('请选择报考学校')
        return
      }else if(this.area2==='') {
        this.$alert('请选择考试地区')
        return
      }else if(this.confirmAddress2==='') {
        this.$alert('请选择确认地点')
        return
      }else if(this.password==='') {
        this.$alert('请输入登录密码')
        return
      }else if(this.teacherName==='') {
        this.$alert('请输入指导老师')
        return
      }
      this.$confirm('如信息填写有误，请联系老师进行修改')
          .then(res => {
            this.active = 2
            this.scrollToTop()
            this.is_disabled = true
          })
    },
    showPay() { //确认信息，并跳到第三步

      this.scrollToTop()
      this.active = 3
    },
    paySubmit() { //提交支付
      let xk = '';//筛选学科
      for(let i in this.applyXuekeArr) {
        if(this.applyXueke===this.applyXuekeArr[i].id) xk = this.applyXuekeArr[i].name
      }
      let info = JSON.parse(localStorage.getItem('jiaoyu'))
      let data = {
        name: this.name,
        mz: this.nation,
        sex: this.gender,
        is_gz: this.is_work,
        date_time: this.birth,
        idcard: this.number,
        tel: this.tel,
        address: this.huji,
        email: this.youjian,
        email_address: this.youji,
        xueli: this.nowXueli,
        bk_xl: this.applyXueli,
        zhuanye_id: this.applyZhuanye,
        xk: xk,
        school_id: this.applySchool,
        ks_address: this.area2,
        qr_address: this.confirmAddress2,
        password: this.password,
        teacher: this.teacherName,
        member_id: info.id,
        image: this.payImg,
        add_time: ''
      }
      this.$axios("POST","/index/bm",data,'提交中')
      .then(res => {
        if(res.code===1) {
          this.$alert('报名成功')
            .then( six => {
              this.scrollToTop()
              this.active = 4
            })
        }else {
          this.$alert(res.msg)
        }
      })
    },
    onsuccess(e) { //上传图片成功回调
      console.log('上传成功',e);
      this.payImg = e.data
    },
    getPayInfo() { //获取付款信息
      this.$axios("POST","/index/pay",{})
      .then(res => {
        if(res.code===1) {
          this.price = res.data.pay_amount
          this.ercode = res.data.pay_image
        }
      })
    },
    getZhuanye(xk_id) { //获取报考专业
      this.$axios("POST","/index/zhuanye_list",{xk_id},'加载中')
      .then(res => {
        if(res.code===1) {
          this.applyZhuanyeArr = res.data
        }
      })
    },
    getXueKe(pname) { //获取学科
      this.$axios("POST","/index/xk_list",{pname},'加载中')
      .then(res => {
        if(res.code===1) {
          this.applyXuekeArr = res.data
        }
      })
    },
    getSchool(pname) { //获取学校
      this.$axios("POST","/index/school_list",{pname})
      .then(res => {
        if(res.code===1) {
          this.schoolArr = res.data
        }
      })
    },
    setArea(e) { //选择考试地区
      let p = CodeToText[e[0]]
      let c = CodeToText[e[1]]
      let a = CodeToText[e[2]]
      this.area2 = `${p},${c},${a}`
    },
    setConfirm(e) { //选择确认地点
      let p = CodeToText[e[0]]
      let c = CodeToText[e[1]]
      let a = CodeToText[e[2]]
      this.confirmAddress2 = `${p},${c},${a}`
    },
  },
  mounted() {
    this.init()
  },
  created() {
    this.getLogoTitle()
    this.getPayInfo()
  },
  watch: {
    applyXueli(newValue) { //选择学历获取学科
      this.getXueKe(newValue)
    },
    applyXueke(newValue) { //选择学科获取专业
      this.getZhuanye(newValue)
    },
    applyZhuanye(newValue) { //根据专业id获取学校
      this.getSchool(newValue)
    },
  }
}
</script>

<style scoped>
  .bg{
    width: 100%;
    /*background: #00B7A4;*/
  }
  .sign_up{
    width: 80%;
    margin: 0 auto;
    background: #FFFFFF;
  }
  .router{
    padding: 2rem;
    box-sizing: border-box;
  }
  .warp{
    width: 100%;
    background: #E5FFFA;
    box-sizing: border-box;
    padding: 2rem;
  }
  .warp_title{
    color: #00B7A4;
    padding-bottom: 2rem;
    border-bottom: 1px solid #929393;
  }
  .logo_warp{
    position: absolute;
    top: 5rem;
    z-index: 22;
    left: 4rem;
  }
  .site_title{
    font-weight: bold;
    color: #FFFFFF;
    font-size: 4rem;
  }
  .logo_warp img{
    width: 8rem;
    height: 8rem;
    border-radius: 50%;
    background: #FFFFFF;
  }
  .item{
    height: 60px;
    box-sizing: border-box;
  }
  .w70{
    width: 50%;
  }
  .button2{
    width: 80%;
    height: 60px;
    font-size: 16px;
    background: #FFFFFF;
    box-sizing: border-box;
    border: 1px solid #BBBBBB;
    color: #101010;
  }
  .button1{
    width: 80%;
    height: 60px;
    font-size: 16px;
    background: #4eac4e;
    color: #FFFFFF;
  }
  .button_warp{
    height: 120px;
  }
  .code{
    width: 22rem;
    height: 22rem;
    background: #cbcbcb;
    margin-top: 5rem;
    margin-bottom: 3.5rem;
  }
  .upLoad{
    width: 12rem;
    height: 12rem;
    background-color: rgba(0, 0, 0, 0.02);
    cursor: pointer;
  }
  @media (max-width: 768px) {
    .sign_up{
      width: 100%;
    }
    .w70{
      width: 70%;
    }
    .button1{
      margin-top: 10px;
    }
    .button_warp{
      height: 150px;
    }
  }
</style>